module.exports = __webpack_public_path__ + "img/03-reduced-range-anxiety.c8e080d4.jpg";